import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Datos de empresa", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Datos de contacto", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Nombre o Razón social*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.Nombre,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetoContacto.Nombre) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.Nombre.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Tipo de identificación*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.TipoDocumento,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objetoContacto.TipoDocumento) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.TipoDocumento.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 8,
            md: 8,
            lg: 8,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "N° de Identificación*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.No_Identificacion,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetoContacto.No_Identificacion) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.No_Identificacion.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "D.V" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.dv,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objetoContacto.dv) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers,
                    maxlength: "1"
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Tipo de Persona*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.TipoPersona,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objetoContacto.TipoPersona) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDePersona, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.TipoPersona.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Clase de sociedad*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.ClaseSociedad,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objetoContacto.ClaseSociedad) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.claseDeSociedad, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.ClaseSociedad.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Tipo de empresa*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.TipoEmpresa,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objetoContacto.TipoEmpresa) = $event)),
                    placeholder: "Seleccionar"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeEmpresa, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.TipoEmpresa.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          (_ctx.objetoContacto.TipoEmpresa == 'Otra')
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "Si es otra ¿Cuál?" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.objetoContacto.OtroTipoEmpresa,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objetoContacto.OtroTipoEmpresa) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.OtroTipoEmpresa.$errors, (error) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: error.$uid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(error.$message), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Dirección" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.Direccion,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objetoContacto.Direccion) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Teléfono" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.Telefono,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objetoContacto.Telefono) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Celular" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.Celular,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objetoContacto.Celular) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "País*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.Pais,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objetoContacto.Pais) = $event)),
                    placeholder: "Seleccionar",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.pais, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.PaisId,
                          label: item.nombre,
                          value: item.nombre
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.Pais.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Departamento*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.Departamento,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objetoContacto.Departamento) = $event)),
                    placeholder: "Seleccionar",
                    filterable: "",
                    disabled: _ctx.objetoContacto.Pais != 'Colombia'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.departamento, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.Departamento.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Ciudad*" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.objetoContacto.Ciudad,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objetoContacto.Ciudad) = $event)),
                    placeholder: "Seleccionar",
                    filterable: "",
                    disabled: _ctx.objetoContacto.Pais != 'Colombia'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.ciudad, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.codigo,
                          label: item.valor,
                          value: item.valor
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.Ciudad.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Correo Electrónico (e-mail)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.Correo,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objetoContacto.Correo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.Correo.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Página Web" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.PaginaWeb,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.objetoContacto.PaginaWeb) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Nombre de Contacto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.NombreContactoCliente,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.objetoContacto.NombreContactoCliente) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Cargo del Contacto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.CargoContactoCliente,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.objetoContacto.CargoContactoCliente) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Correo Electrónico (e-mail)" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.CorreoContactoCliente,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.objetoContacto.CorreoContactoCliente) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionContacto.CorreoContactoCliente.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 9,
            sm: 9,
            md: 9,
            lg: 9,
            xl: 9,
            style: {"padding-right":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Teléfono" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.TelefonoContactoCliente,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.objetoContacto.TelefonoContactoCliente) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 3,
            sm: 3,
            md: 3,
            lg: 3,
            xl: 3,
            style: {"padding-left":"0px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Ext" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.ExtensionContactoCliente,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.objetoContacto.ExtensionContactoCliente) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Celular" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoContacto.CelularContactoCliente,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.objetoContacto.CelularContactoCliente) = $event)),
                    onKeypress: _ctx.func.OnlyNumbers
                  }, null, 8, ["modelValue", "onKeypress"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}